import React from 'react';
import { useTranslation } from '../../../app/LanguageContext';
import CurrencyTextField from './CurrencyTextField';

export const COMPACT_COST_FIELD_WIDTH = 176;
export const COMPACT_PRICE_FIELD_WIDTH = 192;

export default function CostField({
  value,
  onChange,
  label,
  showLabel = true,
  showHelper = true,
  size = 'medium',
  fullWidth = false,
  disabled = false,
  ...rest
}) {
  const { translate } = useTranslation();

  return (
    <CurrencyTextField
      allowEmpty
      size={size}
      fullWidth={fullWidth}
      label={showLabel ? (label ?? translate('core.cost.label')) : undefined}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={translate('core.cost.placeholder')}
      helperText={showHelper ? translate('core.cost.optional_hint') : undefined}
      {...rest}
    />
  );
}
